/**
 * Lit le champ « Limite » du formulaire de recherche.
 *
 * @param raw - Contenu brut du champ.
 * @returns Le nombre maximal de résultats voulu (entier >= 1), ou `null`
 * quand il n'y a pas de limite (champ vide, ou valeur qui n'est pas un
 * entier positif) - la recherche défile alors à l'infini.
 */
export function parseSearchLimit(raw: string): number | null {
	const trimmed = raw.trim();
	if (!/^\d+$/.test(trimmed)) {
		return null;
	}
	const value = Number.parseInt(trimmed, 10);
	return value >= 1 ? value : null;
}
